import {HOME_URL} from "../Util/routes";
import {useState} from 'react';
import {Dialog} from '@headlessui/react';
import Pin from '../Images/map-pin.svg'
import hoverPin from '../Images/hover-map-pin.svg'
import Mail from '../Images/icon-mail.svg'
import Menu from '../Images/Icon-menu.svg'

const NavBar = ({dataNav}) => {

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [pin, setPin] = useState(Pin)

    const changeEnter = () => {
        setPin(hoverPin)
    }

    const changeLeave = () => {
        setPin(Pin)
    }

    return (
        <nav className={`bg-black fixed top-0 w-full z-[900]`}>
            <nav className="flex items-center justify-between p-6 md:px-8" aria-label="Global">
                <div className="flex md:flex-1">
                    <a href={HOME_URL} className="-m-1.5 p-1.5">
                        <span className="sr-only">Your Company</span>
                        <img
                            className="h-12 w-auto"
                            src={dataNav.logo}
                            alt=""
                        />
                    </a>
                </div>
                <div className="flex md:hidden">
                    <button
                        type="button"
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <button className="h-6 w-6" aria-hidden="true"><img src={Menu} alt="open"/></button>
                    </button>
                </div>
                <div className={`hidden md:flex md:flex-1 md:justify-end`}>
                    {dataNav.menu ? dataNav.menu.map((item) => {
                        return (
                            <a href={item.link} className={`mx-10 flex text-[#60CDF5] hover:text-[#F7ABB8]`}>
                                {item.text === 'Encuentra tu salón' ?
                                    <div className={`flex`} onMouseEnter={changeEnter} onMouseLeave={changeLeave}>
                                        <img src={pin} className={`mr-1`}/> {item.text}
                                    </div>
                                    : item.text}
                            </a>
                        )
                    }) : ''}
                </div>
            </nav>
            <Dialog as="div" className={`md:hidden`} open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className="fixed inset-0 z-50"/>
                <Dialog.Panel
                    className={`fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-black px-6 py-6 md:max-w-md md:ring-1 md:ring-gray-900/10`}>
                    <div className="flex items-center justify-between">
                        <a href="#" className="-m-1.5 p-1.5" onClick={e => setMobileMenuOpen(false)}>
                            <span className="sr-only">Your Company</span>
                            <img
                                className="h-12 w-auto"
                                src={dataNav.logo}
                                alt=""
                            />
                        </a>
                        <button
                            type="button"
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Close menu</span>
                            <div className="h-6 w-6" aria-hidden="true"><img src={Menu} alt="close"/></div>
                        </button>
                    </div>
                    <div className="mt-2">
                        <div className="py-6 pl-6">
                            {dataNav.menu ? dataNav.menu.map((item) => {
                                return (
                                    <div className={`mb-5`}>
                                        <a href={item.link} className={`text-[#60CDF5] hover:text-[#F7ABB8]`}
                                           onClick={e => setMobileMenuOpen(false)}>
                                            {item.text === 'Encuentra tu salón' ?
                                                <div className={`flex`}>
                                                    <img src={pin} className={`mr-1`}/> {item.text}
                                                </div>
                                                : item.text}
                                        </a>
                                    </div>
                                )
                            }) : ''}
                            <a href='#subForm' className={`flex text-[#60CDF5] hover:text-[#F7ABB8]`}
                               onClick={e => setMobileMenuOpen(false)}><img src={Mail} alt=""
                                                                            className={`pt-1 pr-1`}/> Contactanos</a>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </nav>
    )
}

export default NavBar;
